import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import LeadsTable from "@/components/dashboard/LeadsTable";
import { Loader2, Power } from "lucide-react";

export default function SellerView() {
  const { user, refreshUser } = useAuth();
  const [available, setAvailable] = useState(user?.available ?? true);
  const [busy, setBusy] = useState(false);

  useEffect(() => { setAvailable(user?.available ?? true); }, [user]);

  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.patch(`/sellers/${user.id}/availability`, { available: !available });
      setAvailable(data.available);
      await refreshUser();
      toast.success(data.available ? "Estás disponible para recibir leads" : "No recibirás nuevos leads");
    } catch (e) { toast.error("Error al cambiar disponibilidad"); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <div className="bg-[#111822] border border-[#1E2D3D] rounded-xl p-5 mb-6 flex items-center justify-between flex-wrap gap-4">
        <div className="flex items-center gap-3">
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${available ? "bg-[#25D366]" : "bg-[#2A181A]"}`}>
            <Power className={`w-6 h-6 ${available ? "text-[#0B0F14]" : "text-[#F87171]"}`} />
          </div>
          <div>
            <h1 className="font-heading text-xl font-bold text-slate-100">Hola, {user?.name}</h1>
            <p className="text-sm text-slate-400">{available ? "Recibiendo leads en tu turno" : "Fuera del reparto"}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm text-slate-300 font-medium">{available ? "Disponible" : "No disponible"}</span>
          {busy ? <Loader2 className="w-5 h-5 text-[#25D366] animate-spin" /> :
            <Switch data-testid="seller-self-availability" checked={available} onCheckedChange={toggle} className="data-[state=checked]:bg-[#25D366]" />}
        </div>
      </div>
      <LeadsTable isAdmin={false} />
    </div>
  );
}
